import { ActivityProgressService } from "@servicesV2";
import { skipToken, useQuery } from "@tanstack/react-query";

import { useService } from "./useService";

export type UseActivityContentQueryParams = {
  courseId: string | undefined;
  activityId: string | undefined;
  learnerId?: string | undefined;
  attempt?: number;
  enabled?: boolean;
};

export function useActivityContentQuery({
  courseId,
  activityId,
  learnerId,
  attempt,
  enabled = true,
}: UseActivityContentQueryParams) {
  const { initialization: activityProgressServiceInit } = useService(
    ActivityProgressService,
  );

  return useQuery({
    queryKey: [
      "activity-content",
      { courseId, activityId, learnerId, attempt },
    ],
    enabled,
    staleTime: Infinity,
    queryFn:
      courseId && activityId
        ? async () => {
            const { service: activityProgressService } =
              await activityProgressServiceInit;

            return activityProgressService.getActivityContent(
              courseId,
              activityId,
              learnerId,
            );
          }
        : skipToken,
  });
}
